import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import noop from 'lodash/noop';
import { Button } from '../button';
import styles from './styles.module.scss';
export var CtaPopup = function (_a) {
    var id = _a.id, showCloseButton = _a.showCloseButton, onClose = _a.onClose, children = _a.children;
    return (_jsxs("div", { className: styles.container, id: "".concat(id || 'some', "-cta-popup"), children: [showCloseButton && (_jsx(Button.Text, { id: "".concat(id || 'some', "-cta-popup-close-button"), className: styles['close-button'], onClick: onClose || noop })), children] }));
};
